import React from "react";
import { FieldContainer } from "../FieldContainer";

interface GeneralInfoProps {
    title: string,
    description?: string
}

export const GeneralInfo: React.FC<GeneralInfoProps> = ({ title, description }) => {
    return (
        <FieldContainer isHeader={true}>
            <h3 className="guardian-header">{title}</h3>
            {description && (
                <p className="guardian-description">{description}</p>
            )}
        </FieldContainer>
    )
}